import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { Form, Col, Button, Modal, ListGroup } from 'react-bootstrap';
import DateTimePicker from 'react-datetime-picker';
import axios from 'axios';
import * as Constants from '../../../constants/constants';

export default function AddJobModal(props) {
    const show = props.show;
    const inputRef = useRef();
    const [jobToAdd, setJobToAdd] = useState({
        Lastname: "",
        Firstname: "",
        Phone: "",
        Vehicle: "",
        Description: "",
        License: "",
        State: "",
        ScheduledDate: new Date(),
        Type: props.scheduled ? "APPOINTMENT" : "",
        Waiting: false
    })

    const [jobSuggestions, setJobSuggestions] = useState([])
    const [showSuggestions, setShowSuggestions] = useState(false)
    const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0, width: 260 })
    const searchDebounce = useRef(null)

    function updateDropdownPos() {
        const modalEl = document.querySelector('.invoice_item_modal .modal-dialog')
        if (modalEl) {
            const rect = modalEl.getBoundingClientRect()
            setDropdownPos({ top: rect.top, left: rect.right + 10, width: 280 })
        }
    }

    function searchJobs(updatedJob) {
        clearTimeout(searchDebounce.current)
        searchDebounce.current = setTimeout(async () => {
            const { Lastname, Phone, Vehicle } = updatedJob
            if (!Lastname && !Phone && !Vehicle) { setJobSuggestions([]); setShowSuggestions(false); return }
            try {
                const res = await axios.post(`${Constants.port}/jobs/search`, {
                    lastname: Lastname,
                    phone: Phone,
                    vehicle: Vehicle
                })
                const seen = new Set()
                const results = (res.data.response || []).filter(job => {
                    const key = `${job.Lastname}|${job.Phone}|${job.Vehicle}`
                    if (seen.has(key)) return false
                    seen.add(key)
                    return true
                })
                setJobSuggestions(results)
                if (results.length > 0) {
                    updateDropdownPos()
                    setShowSuggestions(true)
                } else {
                    setShowSuggestions(false)
                }
            } catch (e) {
                setJobSuggestions([])
                setShowSuggestions(false)
            }
        }, 300)
    }

    function fillFromJob(job) {
        setJobToAdd({
            ...jobToAdd,
            Lastname: job.Lastname || '',
            Firstname: job.Firstname || '',
            Phone: job.Phone || '',
            Vehicle: job.Vehicle || '',
        })
        setShowSuggestions(false)
        setJobSuggestions([])
    }

    function handleFieldChange(field, value) {
        const updated = { ...jobToAdd, [field]: value }
        setJobToAdd(updated)
        searchJobs(updated)
    }

    function myKeyPress(event) {

        if (event.key === "F10") {
            props.add(jobToAdd)
            event.preventDefault()
        }
    }

    function useEventListener(eventName, handler, element = window) {
        // Create a ref that stores handler
        const savedHandler = useRef();

        // Update ref.current value if handler changes.
        // This allows our effect below to always get latest handler ...
        // ... without us needing to pass it in effect deps array ...
        // ... and potentially cause effect to re-run every render.
        useEffect(() => {
            savedHandler.current = handler;
        }, [handler]);

        useEffect(
            () => {
                // Make sure element supports addEventListener
                // On 
                const isSupported = element && element.addEventListener;
                if (!isSupported) return;

                // Create event listener that calls handler function stored in ref
                const eventListener = event => savedHandler.current(event);

                // Add event listener
                element.addEventListener(eventName, eventListener);

                // Remove event listener on cleanup
                return () => {
                    element.removeEventListener(eventName, eventListener);
                };
            },
            [eventName, element] // Re-run if eventName or element changes
        );
    };

    useEffect(()=>{
        inputRef.current.focus();
    }, [])

    useEventListener('keydown', myKeyPress);

    return (
        <>
        {showSuggestions && jobSuggestions.length > 0 && ReactDOM.createPortal(
            <ListGroup style={{ position: 'fixed', top: dropdownPos.top, left: dropdownPos.left, width: dropdownPos.width, maxHeight: '500px', overflowY: 'auto', zIndex: 9999, boxShadow: '0 4px 12px rgba(0,0,0,0.25)', borderRadius: '4px' }}>
                <ListGroup.Item disabled style={{ fontWeight: 'bold', fontSize: '12px', padding: '4px 10px', background: '#f0f0f0' }}>
                    Previous jobs — click to fill
                </ListGroup.Item>
                {jobSuggestions.map((job, i) => (
                    <ListGroup.Item
                        key={i}
                        action
                        onClick={() => fillFromJob(job)}
                        style={{ cursor: 'pointer', fontSize: '13px', padding: '6px 10px' }}
                    >
                        <strong>{job.Lastname}{job.Firstname ? `, ${job.Firstname}` : ''}</strong>
                        {job.Phone ? <div style={{ color: '#555', fontSize: '12px' }}>{job.Phone}</div> : null}
                        {job.Vehicle ? <div style={{ color: '#888', fontSize: '12px' }}>{job.Vehicle}</div> : null}
                    </ListGroup.Item>
                ))}
            </ListGroup>,
            document.body
        )}
        <Modal show={show} onHide={props.close} onKeyPress={(event) => myKeyPress(event)} className="invoice_item_modal">
            <Modal.Header closeButton>
                <Modal.Title>Add a job</Modal.Title>
            </Modal.Header>

            <Modal.Body>
            {jobToAdd.Type === "APPOINTMENT" ?
                   <>
                    <Form.Label>Date</Form.Label>
                    <br/>
                   <DateTimePicker className="testt" disableClock onChange={(e) => setJobToAdd({...jobToAdd, ScheduledDate: e})} value={jobToAdd.ScheduledDate} />
                    </>
                    : null}
                <Form  >


                    <Form.Row>

                        <Form.Group as={Col} >
                            <Form.Label>Last name</Form.Label>
                            <Form.Control autoComplete="new-password" ref={inputRef} value={jobToAdd.Lastname} onChange={(e) => handleFieldChange('Lastname', e.target.value)} />
                        </Form.Group>

                        <Form.Group as={Col} >
                            <Form.Label>First name</Form.Label>
                            <Form.Control autoComplete="new-password" value={jobToAdd.Firstname} onChange={(e) => setJobToAdd({ ...jobToAdd, Firstname: e.target.value })} />
                        </Form.Group>

                        {jobToAdd.Type !== "APPOINTMENT" ?
                        <Form.Group as={Col} xs={2}>
                        <Form.Label>Waiting</Form.Label>
                        <br/>
                        <input checked={jobToAdd.Waiting} onChange={(e)=>setJobToAdd({...jobToAdd, Waiting: e.target.checked})} type='checkbox' style={{height:"25px", width:"20px", margin:"auto"}} />
                    </Form.Group>
                    : null}
                    </Form.Row>

                    <Form.Label>Phone</Form.Label>
                    <Form.Control autoComplete="new-password" value={jobToAdd.Phone} onChange={(e) => handleFieldChange('Phone', e.target.value)} />
                    <Form.Label>Vehicle</Form.Label>
                    <Form.Control value={jobToAdd.Vehicle} onChange={(e) => handleFieldChange('Vehicle', e.target.value)} />

                    <Form.Label>Description</Form.Label>
                    <Form.Control autoComplete="new-password" as="textarea" rows="5" value={jobToAdd.description} onChange={(e) => setJobToAdd({ ...jobToAdd, Description: e.target.value })} />
                 
                   

                </Form>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={props.close}> Close </Button>
                <Button variant="primary" onClick={props.add.bind(this, jobToAdd)}> Save Changes </Button>
            </Modal.Footer>

        </Modal>
        </>
    )
}